import { render, staticRenderFns } from "./ProjectBarComponent.vue?vue&type=template&id=2a354c4e&scoped=true&"
import script from "./ProjectBarComponent.vue?vue&type=script&lang=js&"
export * from "./ProjectBarComponent.vue?vue&type=script&lang=js&"
import style0 from "./ProjectBarComponent.vue?vue&type=style&index=0&id=2a354c4e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a354c4e",
  null
  
)

export default component.exports